import React from 'react';
import { RefreshCw, IdCard } from 'lucide-react';

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const ESTADO_BADGE = {
  'PRE-APROBADO': 'bg-amber-100 text-amber-700 ring-amber-200',
  'APROBADO': 'bg-emerald-100 text-emerald-700 ring-emerald-200',
};

// Panel presentacional del detalle de créditos aprobados/pre-aprobados de un
// vendedor (ventana móvil hoy-35 a hoy-5 días). El fetch y el cache viven en
// el componente padre; este solo pinta el estado recibido.
export function ClientesAprobadosDetalle({ estado }) {
  const { loading, error, data = [] } = estado || { loading: true, error: null, data: [] };

  if (loading) {
    return (
      <div className="flex items-center gap-2 py-4 text-slate-500">
        <RefreshCw size={14} className="animate-spin text-morado" />
        <span className="text-xs font-medium">Cargando créditos...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
        {error}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="flex items-center gap-2 py-3 text-slate-400">
        <IdCard size={16} />
        <span className="text-xs">Sin créditos aprobados/pre-aprobados en el período evaluado (últimos 5 a 35 días).</span>
      </div>
    );
  }

  return (
    <table className="min-w-full text-xs">
      <thead>
        <tr className="border-b border-slate-200 text-left text-[10px] font-bold uppercase tracking-wider text-slate-400">
          <th className="py-1.5 pr-4">Cédula</th>
          <th className="py-1.5 pr-4">Nombre</th>
          <th className="py-1.5 pr-4">N° Solicitud</th>
          <th className="py-1.5 pr-4">Fecha</th>
          <th className="py-1.5 pr-4">Estado</th>
          <th className="py-1.5 pr-4">Verif. Documental</th>
          <th className="py-1.5 pr-4">Verif. Telefónica</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={`${row.Cedula}-${idx}`} className="border-b border-slate-100 last:border-0">
            <td className="py-1.5 pr-4 font-medium text-slate-700">{row.Cedula}</td>
            <td className="py-1.5 pr-4 text-slate-600">{row.NombreCompleto}</td>
            <td className="py-1.5 pr-4 text-slate-600">{row.NumeroSolicitud}</td>
            <td className="py-1.5 pr-4 text-slate-600">{formatDate(row.Fecha)}</td>
            <td className="py-1.5 pr-4">
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ring-1 ${ESTADO_BADGE[row.Estado] || 'bg-slate-100 text-slate-600 ring-slate-200'}`}>
                {row.Estado}
              </span>
            </td>
            <td className="py-1.5 pr-4 text-slate-600">{row.VerificacionDocumental}</td>
            <td className="py-1.5 pr-4 text-slate-600">{row.VerificacionTelefonica}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
